import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { LoopPlannerScenarioApi } from '@/features/planner/api/scenario';
import { plannerQueryKeys } from '@/features/planner/queryKeys';

export const getScenariosQueryOptions = ({ loopId }: { loopId: number }) =>
  queryOptions({
    queryKey: plannerQueryKeys.scenarios.list({ loopId }),
    queryFn: () => LoopPlannerScenarioApi.getScenarios({ loopId }),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });

export const useGetScenariosSuspense = ({ loopId }: { loopId: number }) => {
  return useSuspenseQuery(getScenariosQueryOptions({ loopId }));
};

export const useGetScenarios = ({ loopId }: { loopId: number }) => {
  return useQuery(getScenariosQueryOptions({ loopId }));
};
